(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        /*
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        */
        // Role list for editing. DON'T REMOVE!
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_EXTERNAL_SYS', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_MAIN_CHECKER', 'ROLE_CHECKER', 'ROLE_MARKETER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
